export const initialEnergyChargeData = [
  { x: 0, y: 0.17133 },
  { x: 1, y: 0.17133 },
  { x: 2, y: 0.17133 },
  { x: 3, y: 0.17133 },
  { x: 4, y: 0.17133 },
  { x: 5, y: 0.17133 },
  { x: 6, y: 0.17133 },
  { x: 7, y: 0.17133 },
  { x: 8, y: 0.17133 },
  { x: 9, y: 0.17133 },
  { x: 10, y: 0.17133 },
  { x: 11, y: 0.17133 },
  { x: 12, y: 0.17133 },
  { x: 13, y: 0.17133 },
  { x: 14, y: 0.17133 },
  { x: 15, y: 0.17133 },
  { x: 16, y: 0.46034 },
  { x: 17, y: 0.46034 },
  { x: 18, y: 0.46034 },
  { x: 19, y: 0.46034 },
  { x: 20, y: 0.46034 },
  { x: 21, y: 0.17133 },
  { x: 22, y: 0.17133 },
  { x: 23, y: 0.17133 },
];

const collapseTouRatePoints = (points) => {
  const numericPoints = points
    .map(({ x, y }) => ({
      x: Number(x),
      y: Number(y),
    }))
    .filter(({ x, y }) => Number.isFinite(x) && x >= 0 && Number.isFinite(y));

  if (numericPoints.length === 0) {
    return initialEnergyChargeData;
  }

  const maxX = Math.max(...numericPoints.map(({ x }) => x));
  let collapseDivisor = 1;
  while (maxX >= 24 * collapseDivisor) {
    collapseDivisor *= 4;
  }

  const buckets = new Map();
  numericPoints.forEach(({ x, y }) => {
    const hour = Math.floor(x / collapseDivisor);
    if (hour < 0 || hour > 23) {
      return;
    }
    const current = buckets.get(hour) || { total: 0, count: 0 };
    current.total += y;
    current.count += 1;
    buckets.set(hour, current);
  });

  if (buckets.size === 0) {
    return initialEnergyChargeData;
  }

  return Array.from(buckets.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([x, stats]) => ({
      x,
      y: stats.total / stats.count,
    }));
};

export const expandEnergyChargeData = (data) => {
  return data.reduce((result, { x, y }) => {
    for (let i = 0; i < 4; i += 1) {
      result[x * 4 + i] = y;
    }
    return result;
  }, {});
};

export const normalizeTouRatesForEditor = (touRates) => {
  if (Array.isArray(touRates)) {
    return collapseTouRatePoints(touRates);
  }

  if (touRates && typeof touRates === "object") {
    return collapseTouRatePoints(Object.entries(touRates).map(([x, y]) => ({ x, y })));
  }

  return initialEnergyChargeData;
};
